import React, { useEffect } from "react";
import "./DaanUtsavProject2.css";
import musoVideo from "../../../images/KU team 2025/Project 2/MuSo.mp4";

const DaanUtsavProject2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="daanutsav-project2">
      <div className="center-part col">
        <div className="project-head row">Daan Utsav 2025 - Museum of Solutions Visit</div>

        <div className="content-video-row">
          <div className="video-column">
            <video className="project-video" controls>
              <source src={musoVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <div className="content-column">
            <p className="text">
              Kindness Unlimited, in collaboration with the Museum of Solutions, organized a Daan Utsav event for 160 students from Ramji Assar Gujarati Vidyalaya, Ghatkopar.
              <br /><br />
              The initiative, supported by STEM volunteers from St. Andrew's college of Arts, Science and Commerce, Bandra, provided an engaging platform for students to explore, learn, and connect through experiential activities.
              <br /><br />
              The event reinforced the value of giving as a means to inspire, educate, and foster meaningful community engagement.
            </p>
            
            <div className="instagram-link">
              <a href="https://www.instagram.com/reel/DPnlbtcjMnO/?igsh=M2czenV5YzZjODBo" target="_blank" rel="noopener noreferrer" className="instagram-button">
                <i className="fab fa-instagram"></i> View on Instagram
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DaanUtsavProject2;
